import styled from 'styled-components';
import { Tablet } from '../../../atoms/_Variable/var';

export const Wrapper = styled.section`
	margin-top: 80px;
	padding-top: 6rem;
	padding-bottom: 2.813rem;
	background-color: #f9fbff;

	.topIndex {
		z-index: 9;
		position: relative;
	}

	.textWrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		text-align: center;
		padding-left: 10%;
		padding-right: 10%;
		@media only screen and (max-width: 1400px) {
			padding-left: 5%;
			padding-right: 5%;
		}
		@media only screen and (max-width: ${Tablet}) {
			padding-left: 0;
			padding-right: 0;
		}
		.bannerImg {
			width: 221px;
			margin-bottom: 2.75rem;
			position: relative;
			z-index: 99;
		}
		.pDefault {
			margin-top: 1.25rem;
		}
		.btnPrimaryDefault {
			margin-top: 1.25rem;
		}
		.expand-more {
			border: none;
			background-color: transparent;
			margin-top: 2.875rem;
			&:focus {
				outline: none;
			}
		}
	}

	.quarterCircle {
		background-image: url(https://seiturju.sirv.com/Chatbiz/homepage/QuarterCircle.svg);
		width: 300px;
		height: 361px;

		transform: scale(1);
		position: absolute;
		top: 82px;
		right: 0;
		background-repeat: no-repeat;
		z-index: 1;

		transform-origin: right top;
		@media only screen and (max-width: ${Tablet}) {
			transform: scale(0.6);
			top: 60px;
			opacity: 0.25;
		}
	}
`;

export default Wrapper;
